module.exports = __webpack_public_path__ + "media/fonts/formular-medium-webfont-41757145a0eeb1d489cbd0734a59ae01.woff";